module.exports = __webpack_public_path__ + "img/bg-last-month.ac3bd69b.svg";